export default __webpack_public_path__ + "static/cloud-native-management-ee66fd84057c1fbd11f50823dda240b2.webp";